import { render, staticRenderFns } from "./PurchaseBusinessStatistics.vue?vue&type=template&id=2f0bed42&scoped=true&"
import script from "./PurchaseBusinessStatistics.vue?vue&type=script&lang=js&"
export * from "./PurchaseBusinessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseBusinessStatistics.vue?vue&type=style&index=0&id=2f0bed42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0bed42",
  null
  
)

export default component.exports